import { isEmpty } from 'ramda'
import { useIntl } from 'react-intl'
import { useCMSPageField } from '@/cms/fields'
import { ScoreBar } from './ScoreBar'
import styles from './ScoreBars.module.css'

export function ScoreBars() {
  const intl = useIntl()
  const scoreByCategory = useCMSPageField('userReviews.scoreByCategory')

  return (
    <>
      {!isEmpty(scoreByCategory) && (
        <div className={styles.scoreBarTable}>
          {scoreByCategory.map(score => (
            <ScoreBar
              key={score.typeId}
              score={score.score}
              label={intl.formatMessage({ id: `reviews_score_bar_label_${score.typeId}` })}
            />
          ))}
        </div>
      )}
    </>
  )
}
